<template>
  <div class="roleEditBox">
    <Form ref="editForm" :label-width="80" :model="formCustom" :rules="editRules" inline>
      <Form-item label="角色名称：" prop="roleName">
        <Input v-model="formCustom.roleName" :maxlength="50" clearable placeholder="请输入"
               style="width: 200px"></Input>
      </Form-item>
      <br>
      <Form-item label="角色类型：" prop="roleType">
        <Select v-model="formCustom.roleType" clearable filterable style="width: 200px">
          <Option value="2">前道</Option>
          <Option value="3">后道</Option>
        </Select>
      </Form-item>
      <br>
      <Form-item label="别名：" prop="remarks">
        <Input v-model="formCustom.remarks" :maxlength="50" clearable placeholder="请输入" style="width: 200px"></Input>
      </Form-item>
      <br>
      <Form-item label="排序：" prop="orderBy">
        <Input v-model="formCustom.orderBy" :maxlength="50" clearable placeholder="请输入" style="width: 200px"></Input>
      </Form-item>
      <br>
    </Form>
    <div class="footerButton">
      <Button type="default" @click="handleBack('add')">返回</Button>
      <Button :loading="editLoading" style="margin-left: 10px" type="primary" @click="handleCommit('editForm')">
        <span v-if="!editLoading">提交</span>
        <span v-else>提交中</span>
      </Button>
    </div>
  </div>
</template>

<script>
import {roleDetail, roleEdit} from '@/api/authority'

export default {
  name: 'roleEdit',
  data() {
    return {
      roleId: '', // 获取编辑的Id
      editLoading: false,
      formCustom: {
        roleName: '',
        remarks: '',
        orderBy: '',
        roleType: ''
      },
      editRules: {
        roleName: [{required: true, message: '角色名称不能为空', trigger: 'blur'}],
        roleType: [{required: true, message: '角色类型不能为空', trigger: 'change'}]
      }
    }
  },
  mounted() {
    this.roleId = this.$route.query.roleId
    roleDetail(this.roleId).then((res) => {
      this.formCustom = res.data.data
      this.formCustom.roleType = res.data.data.roleType.toString()
    })
  },
  methods: {
    // 返回
    handleBack() {
      this.$router.push(
        {
          path: '/authority/role',
          query: {
            current: this.$route.query.current,
            size: this.$route.query.size,
            roleName: this.$route.query.roleName
          }
        }
      )
    },
    // 提交
    handleCommit(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.editLoading = true
          roleEdit({
            roleId: this.roleId,
            roleName: this.formCustom.roleName,
            remarks: this.formCustom.remarks,
            orderBy: this.formCustom.orderBy,
            roleType: this.formCustom.roleType
          }).then((response) => {
            if (response.data.success === false) {
              this.$Message.error(response.data.msg)
              this.editLoading = false
            } else {
              this.$Message.success(response.data.msg)
              this.editLoading = false
              this.$router.push({name: 'role'})
            }
          }).catch(() => {
            this.editLoading = false
          })
        }
      })
    }
  }
}
</script>
